module.exports = __webpack_public_path__ + "static/media/sbom-slide-6.071fad65.jpg";